import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getContentBlockerNodes, transformToOriginalContentBlockerAttribute, putScriptInlineToDom, createContentBlocker } from ".";
import { unmountComponentAtNode } from "react-dom";
import { OPT_IN_CONTENT_BLOCKER } from "../../types";
import { applyJQueryInitiator, applyNativeEventListener, applyJQueryEvent, customUnblockTriggers } from "..";
import { probablyResetParentContainerForContentBlocker, applyContentBlockerStyleRule, HTML_ATTRIBUTE_COOKIE_IDS, HTML_ATTRIBUTE_BLOCKER_CONNECTED, HTML_ATTRIBUTE_INLINE } from ".";
import { BLOCKER_LAST_CLICKED_CONNECTED_COUNTER } from "../../components";
/**
 * Refresh the DOM content depending on accepted cookies. It covers the following things:
 *
 * - Get all available blocked content
 * - Unblock blocked content depending on the passed accepted cookies
 * - All other blocked content gets a visual content-blocker (if possible)
 */

function manipulateContentBlockerDOM(_x) {
  return _manipulateContentBlockerDOM.apply(this, arguments);
}

function _manipulateContentBlockerDOM() {
  _manipulateContentBlockerDOM = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cookies) {
    var nodes, unblockedNodes, _iterator, _step, row, consent, node, blocker, connectedBlocker, isLastClicked, contentBlockers, _iterator2, _step2, contentBlocker, ownerDocument, defaultView;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            nodes = getContentBlockerNodes(cookies);
            applyContentBlockerStyleRule(cookies); // A collection of all unblocked content for this "transaction"; so we can keep track a batch
            // of unblocked items to keep dependencies intact (e.g. Custom script is blocked and needs Google Maps
            // API do be available).

            unblockedNodes = [];
            _iterator = _createForOfIteratorHelper(nodes);
            _context.prev = 4;

            _iterator.s();

          case 6:
            if ((_step = _iterator.n()).done) {
              _context.next = 36;
              break;
            }

            row = _step.value;
            consent = row.consent, node = row.node, blocker = row.blocker;

            if (!consent) {
              _context.next = 33;
              break;
            }

            // Immediate deactivate nodes for future unblocks
            node.removeAttribute(HTML_ATTRIBUTE_COOKIE_IDS); // Remove visual content blocker if given

            connectedBlocker = node.getAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED);
            isLastClicked = "".concat(BLOCKER_LAST_CLICKED_CONNECTED_COUNTER.count) === connectedBlocker;

            if (isLastClicked) {
              BLOCKER_LAST_CLICKED_CONNECTED_COUNTER.count = undefined; // Reset to avoid double auto plays
            }

            if (connectedBlocker) {
              contentBlockers = Array.prototype.slice.call(document.querySelectorAll(".rcb-content-blocker[consent-blocker-connected=\"".concat(connectedBlocker, "\"]")));
              _iterator2 = _createForOfIteratorHelper(contentBlockers);

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  contentBlocker = _step2.value;
                  unmountComponentAtNode(contentBlocker);
                  probablyResetParentContainerForContentBlocker(contentBlocker, false);
                  contentBlocker.remove();
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } // Overwrite global listeners so they get immediate executed


            ownerDocument = node.ownerDocument;
            defaultView = ownerDocument.defaultView;
            applyJQueryInitiator(ownerDocument);
            applyNativeEventListener(defaultView, "load");
            applyNativeEventListener(ownerDocument, "DOMContentLoaded");
            applyJQueryEvent(ownerDocument, defaultView, "elementor/frontend/init"); // Activate node

            if (!node.hasAttribute(HTML_ATTRIBUTE_INLINE)) {
              _context.next = 26;
              break;
            }

            _context.next = 24;
            return putScriptInlineToDom(node);

          case 24:
            _context.next = 28;
            break;

          case 26:
            _context.next = 28;
            return transformToOriginalContentBlockerAttribute(node, isLastClicked);

          case 28:
            node.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER, {
              detail: {
                blocker: blocker,
                gotClicked: isLastClicked
              }
            }));
            document.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER, {
              detail: {
                blocker: blocker,
                element: node,
                gotClicked: isLastClicked
              }
            }));
            unblockedNodes.push(row);
            _context.next = 34;
            break;

          case 33:
            createContentBlocker(row);

          case 34:
            _context.next = 6;
            break;

          case 36:
            _context.next = 41;
            break;

          case 38:
            _context.prev = 38;
            _context.t0 = _context["catch"](4);

            _iterator.e(_context.t0);

          case 41:
            _context.prev = 41;

            _iterator.f();

            return _context.finish(41);

          case 44:
            customUnblockTriggers(unblockedNodes);

          case 45:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 38, 41, 44]]);
  }));
  return _manipulateContentBlockerDOM.apply(this, arguments);
}

export { manipulateContentBlockerDOM };